
/* @ngInject */
function MarketingCalendarListController ($rootScope, $scope, $translate, Utils) {
  activate()

  function activate () {}
}

export { MarketingCalendarListController }
